import * as THREE from "three";
import * as ZapparThree from "@zappar/zappar-threejs";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { gsap } from "gsap";

let clock = new THREE.Clock();
let duckAnim: THREE.AnimationAction;
let mixer: any;

let room: any;
let duck: any;

const roomModelSrc = new URL("../assets/models/Elmo_Dino_Room.glb", import.meta.url).href;
const duckModelSrc = new URL("../assets/models/Elmo_Dino_Room_Ducks.glb", import.meta.url).href;
const backgroundSrc = new URL("../assets/images/evening_meadow.jpg", import.meta.url).href;

export function initRoom(faceTrackerGroup: any, manager: any, scene: THREE.Scene) {
  let background = new THREE.Mesh(
    new THREE.SphereGeometry(20, 32, 16),
    new THREE.MeshBasicMaterial({
      map: new THREE.TextureLoader().load(backgroundSrc),
      side: THREE.DoubleSide,
    })
  );
  faceTrackerGroup.add(background);

  //ROOM
  new GLTFLoader(manager).load(
    roomModelSrc,
    function (gltf) {
      room = gltf.scene;
      room.scale.set(0.075, 0.075, 0.075);
      room.position.set(0, -1.7, -2);
      faceTrackerGroup.add(room);
      room.recieveShadow = true;

      room.traverse(function (node: any) {
        if (node.isMesh) {
          node.material.side = THREE.DoubleSide;
          node.renderOrder = -1;
          if (node.name == "Window_Glass") {
            let material = new THREE.MeshStandardMaterial({
              roughness: 0.0,
              metalness: 0.0,
              transparent: true,
              opacity: 0.5,
              side: THREE.DoubleSide,
            });

            node.material = material;
            //node.material = new THREE.MeshStandardMaterial({ transparent : true, opacity : 0.5, alphaTest : 0, metalness : 0.0, roughness : 0.0})
          } else {
            node.castShadow = true;
            node.receiveShadow = true;
          }
        }
      });
    },
    undefined,
    function (error) {
      console.log("An error happened");
    }
  );

  //Duck
  new GLTFLoader(manager).load(
    duckModelSrc,
    function (gltf) {
      duck = gltf.scene;
      duck.scale.set(0.75, 0.75, 0.75);
      faceTrackerGroup.add(duck);
      duck.recieveShadow = true;

      duck.traverse(function (node: any) {
        if (node.isMesh) {
          node.material.side = THREE.DoubleSide;
          node.renderOrder = -1;
          node.castShadow = true;
          node.receiveShadow = true;
        }
      });

      let animations = gltf.animations;

      mixer = new THREE.AnimationMixer(gltf.scene);
      for (var i = 0; i < animations.length; i++) {
        var animation = animations[i];
        animation.duration = 1000;
        var animClip = THREE.AnimationUtils.subclip(animation, "duckAnim", 0, 1000);
        duckAnim = mixer.clipAction(animClip);
      }
      duckAnim.play();
    },
    // called while loading is progressing
    undefined,
    function (error) {
      console.log("An error happened");
    }
  );
}

export function hideRoom() {
  room.visible = false;
  // roomGroup.visible = false;
}

export function revealRoom() {
  room.visible = true;
  // roomGroup.visible = true;
}

export function roomShake() {
  gsap.to(room.position, 0.05, { x: "+=0.5", yoyo: true, repeat: 15 });
}

export function animationDuckUpdates() {
  let delta = clock.getDelta();
  if (mixer) mixer.update(delta);
}
